//平台内置弹框内的组件
const DesDataGridExpColChoose = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_sys_modal" */ "./dataGridExpColChoose"));
const DesCommonImportErrorDataEidt = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_sys_modal" */ "./commonImportErrorDataEidt"));
const DsfExportSetting = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_sys_modal" */ "./exportSetting"));
const DsfCatalogueOptions = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_sys_modal" */ "./catalogue"));
const DsfPlatformSlideVerify = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_sys_modal" */ "./slideVerify.vue"));
function install(Vue) {
  Vue.component("DesDataGridExpColChoose", DesDataGridExpColChoose);
  Vue.component("DesCommonImportErrorDataEidt", DesCommonImportErrorDataEidt);
  Vue.component("DsfExportSetting", DsfExportSetting);
  Vue.component("DsfCatalogueOptions", DsfCatalogueOptions);
  Vue.component("DsfPlatformSlideVerify", DsfPlatformSlideVerify);
}
export default install;
